export default "__VITE_ASSET__BoNdaVzg__"